module.exports = "/images/arrow-back.svg?4ae891489dc56e5d8dc3df45b42c4408";